module.exports = __webpack_public_path__ + "img/portrait-064.4597e71a.jpg";